export * from '@primeuix/themes/lara/tieredmenu';
export { default } from '@primeuix/themes/lara/tieredmenu';
